export default "__VITE_ASSET__CiFVoYcD__"